/* THIS IS FILE IS AUTO-GENERATED BY graphql-codegen. DO NOT EDIT THIS FILE DIRECTLY! */
/* eslint-disable eslint-comments/no-unlimited-disable */
/* eslint-disable */
import * as Types from "../../types/definitions/vendor/graphql-schema.d";
import { DocumentNode } from "graphql";
import * as Apollo from "@apollo/client";
const defaultOptions = {} as const;
export type CreateSavedItemMutationVariables = Types.Exact<{
  id: Types.Scalars["ID"]["input"];
}>;
export type CreateSavedItemMutation = {
  __typename?: "Mutation";
  savedItemCreate?: {
    __typename?: "SavedItemCreatePayload";
    result: {
      __typename?: "SavedItemCreateResult";
      sku: {
        __typename?: "SavedItemSku";
        id: string;
      };
    };
  } | null;
};
export const CreateSavedItemDocument = {
  kind: "Document",
  definitions: [{
    kind: "OperationDefinition",
    operation: "mutation",
    name: {
      kind: "Name",
      value: "createSavedItem"
    },
    variableDefinitions: [{
      kind: "VariableDefinition",
      variable: {
        kind: "Variable",
        name: {
          kind: "Name",
          value: "id"
        }
      },
      type: {
        kind: "NonNullType",
        type: {
          kind: "NamedType",
          name: {
            kind: "Name",
            value: "ID"
          }
        }
      }
    }],
    selectionSet: {
      kind: "SelectionSet",
      selections: [{
        kind: "Field",
        name: {
          kind: "Name",
          value: "savedItemCreate"
        },
        arguments: [{
          kind: "Argument",
          name: {
            kind: "Name",
            value: "input"
          },
          value: {
            kind: "ObjectValue",
            fields: [{
              kind: "ObjectField",
              name: {
                kind: "Name",
                value: "productEventsContext"
              },
              value: {
                kind: "ObjectValue",
                fields: [{
                  kind: "ObjectField",
                  name: {
                    kind: "Name",
                    value: "source"
                  },
                  value: {
                    kind: "StringValue",
                    value: "search_results",
                    block: false
                  }
                }]
              }
            }, {
              kind: "ObjectField",
              name: {
                kind: "Name",
                value: "sku"
              },
              value: {
                kind: "ObjectValue",
                fields: [{
                  kind: "ObjectField",
                  name: {
                    kind: "Name",
                    value: "id"
                  },
                  value: {
                    kind: "Variable",
                    name: {
                      kind: "Name",
                      value: "id"
                    }
                  }
                }]
              }
            }]
          }
        }],
        selectionSet: {
          kind: "SelectionSet",
          selections: [{
            kind: "Field",
            name: {
              kind: "Name",
              value: "result"
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{
                kind: "Field",
                name: {
                  kind: "Name",
                  value: "sku"
                },
                selectionSet: {
                  kind: "SelectionSet",
                  selections: [{
                    kind: "Field",
                    name: {
                      kind: "Name",
                      value: "id"
                    }
                  }]
                }
              }]
            }
          }]
        }
      }]
    }
  }]
} as unknown as DocumentNode;
export type CreateSavedItemMutationFn = Apollo.MutationFunction<CreateSavedItemMutation, CreateSavedItemMutationVariables>;

/**
 * __useCreateSavedItemMutation__
 *
 * To run a mutation, you first call `useCreateSavedItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSavedItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSavedItemMutation, { data, loading, error }] = useCreateSavedItemMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCreateSavedItemMutation(baseOptions?: Apollo.MutationHookOptions<CreateSavedItemMutation, CreateSavedItemMutationVariables>) {
  const options = {
    ...defaultOptions,
    ...baseOptions
  };
  return Apollo.useMutation<CreateSavedItemMutation, CreateSavedItemMutationVariables>(CreateSavedItemDocument, options);
}
export type CreateSavedItemMutationHookResult = ReturnType<typeof useCreateSavedItemMutation>;
export type CreateSavedItemMutationResult = Apollo.MutationResult<CreateSavedItemMutation>;
export type CreateSavedItemMutationOptions = Apollo.BaseMutationOptions<CreateSavedItemMutation, CreateSavedItemMutationVariables>;